import React, { useCallback } from 'react'

const withContainer = Component => () => {
  const companyAutocompleteMutator = useCallback((q) => ({ name: { contains: q } }), [])
  const contractAutocompleteMutator = useCallback((q) => ({ client_id: { contains: q } }), [])
  const serviceAutocompleteMutator = useCallback((q) => ({ client_id: { contains: q } }), [])
  const getStatusOptionProps = useCallback((props) => ({ _typography: { color: !!props?.value ? 'green' : 'orange' } }), [])

  const mergedProps = {
    companyAutocompleteMutator,
    contractAutocompleteMutator,
    serviceAutocompleteMutator,
    getStatusOptionProps,
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
